/** PaperlessNOW design tokens shared by the admin and employee experiences. */
export const tokens = {
  color: {
    // chrome
    ink: "#063F39",
    inkRaised: "#07534A",
    inkLine: "rgba(255, 255, 255, 0.12)",
    onInk: "#E5F5F2",
    onInkFaint: "#9ECAC2",
    tealOnInk: "#37D5B9",

    // content surfaces
    canvas: "#F5F8F7",
    paper: "#FFFFFF",
    mint: "#EAF8F5",
    mintLine: "#B9E1D9",
    cardLine: "#DDE7E4",
    rowLine: "#E8EFED",

    // text
    inkText: "#173832",
    subText: "#627771",
    labelText: "#46615A",

    // interaction
    primary: "#0B9F84",
    primaryHover: "#07846D",
    onPrimary: "#FFFFFF",
    focusRing: "rgba(12, 185, 157, 0.22)",
    inputLine: "#C9D8D4",
    inputBg: "#FFFFFF",

    // data & status
    data: "#068D6F",
    good: "#1C7A4E",
    bad: "#B3402F",
    flag: "#B77816",
  },
  font: {
    display: "'Sora', system-ui, -apple-system, 'Segoe UI', sans-serif",
    body: "'Sora', system-ui, -apple-system, 'Segoe UI', sans-serif",
    mono: "ui-monospace, SFMono-Regular, Menlo, monospace",
  },
  radius: {
    card: 12,
    control: 8,
  },
  layout: {
    drawerWidth: 248,
    topBarHeight: 64,
    contentMaxWidth: 1280,
  },
};
